import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ActionButton } from 'components/ui/Button';
import styled from 'styled-components';

const StyledButtonWrapper = styled.div`
  display: inline-flex;
`;

const ResetPasswordConfirmation = ({ email }) => (
  <>
    <div>
      <FormattedMessage id="resetPassword.confirmation" values={{ email }} />
    </div>
    <StyledButtonWrapper>
      <ActionButton id="backToLogin" href="/" width={2} space="vertical">
        <FormattedMessage id="resetPassword.confirmation.cta" />
      </ActionButton>
    </StyledButtonWrapper>
  </>
);

ResetPasswordConfirmation.propTypes = {
  email: PropTypes.string.isRequired
};

export default ResetPasswordConfirmation;
